export const noop = () => undefined;

export const noopPromise = () => Promise.resolve(undefined);

export const nullNoopPromise = () => Promise.resolve(null);

export const stringNoop = () => '';
